import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { map, Subject, takeUntil } from 'rxjs';
import { NavigationService } from '../../../public-api';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'lib-app-mobile-first-layout',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './app-mobile-first-layout.component.html',
  styleUrl: './app-mobile-first-layout.component.scss'
})
export class AppMobileFirstLayoutComponent {
  @Input() appTitle = 'Smart Parking';
  private destroy$ = new Subject<void>();
  isHandset = false;
  isNavCollapsed = false;
  private navigationService = inject(NavigationService);
  private breakpointObserver = inject(BreakpointObserver);

  ngOnInit(): void {
    this.navigationService.getCollapseState().subscribe(collapsed => {
      this.isNavCollapsed = collapsed;
    });
    this.setupBreakpoints();
  }

  private setupBreakpoints(): void {
    this.breakpointObserver.observe([Breakpoints.Handset, Breakpoints.Tablet])
      .pipe(
        takeUntil(this.destroy$),
        map(result => result.matches)
      )
      .subscribe(isHandset => {
        this.isHandset = isHandset;
        // Always collapse on mobile devices
        if (isHandset) {
          this.navigationService.setCollapse(true);
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}